import { render } from "./ViewTemplates.vue?vue&type=template&id=1dd2dca0"
import script from "./ViewTemplates.vue?vue&type=script&lang=js"
export * from "./ViewTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__